<template>
  <div class="flow-line-four-steps">
    <ul class="flow-line-block">
      <li
        v-for="(step, index) in steps"
        :key="index"
        class="flow-line-box"
        :class="{ active: index + 1 === activeStep }"
      >
        <div class="flow-line-circle">
          <span class="flow-line-no">{{ index + 1 }}</span>
        </div>
        <div class="flow-line-status">
          {{ step }}
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    steps: {
      type: Array,
      required: true,
      validator(value) {
        return value.length === 4
      }
    },
    activeStep: {
      type: Number,
      required: true
    }
  }
}
</script>
